import tw from "twin.macro";

export const Container = tw.div`
  flex h-screen xl:w-[1200px] lg:w-[900px] md:w-[600px] sm:w-[400px] w-[300px] mx-auto pb-5 
`

export const LoadingContainer = tw.div`
  flex items-center justify-center text-white mt-5 font-bold
`